import {
    SUBSCRIBE_MEMBER_CHECKOUT_REQUEST,
    SUBSCRIBE_MEMBER_CHECKOUT_SUCCESS,
    SUBSCRIBE_MEMBER_CHECKOUT_FAILURE,
    SUBSCRIBE_CLUB_CHECKOUT_REQUEST,
    SUBSCRIBE_CLUB_CHECKOUT_SUCCESS,
    SUBSCRIBE_CLUB_CHECKOUT_FAILURE,
    SUBSCRIBE_SUBSCRIPTION_INFO_REQUEST,
    SUBSCRIBE_SUBSCRIPTION_INFO_SUCCESS,
    SUBSCRIBE_UPDATE_PAYMENT_SUCCESS,
    SUBSCRIBE_UPDATE_PAYMENT_REQUEST,
    SUBSCRIBE_UPDATE_PAYMENT_FAILURE,
    SUBSCRIBE_MEMBER_CANCEL_SUCCESS,
    SUBSCRIBE_MEMBER_RENEW_SUCCESS,
    SUBSCRIBE_CLUB_RENEW_SUCCESS,
    SUBSCRIBE_INVOICE_PRINT,
    SUBSCRIBE_MEMBER_CLEAR_ERROR,
} from '../actions/subscribe-action-types';

const initialState = {
    loading: false,
    subscriptions: [],
    invoices: [],
    hasTestClock: null,
    cardError: null,
    selectedInvoice: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SUBSCRIBE_UPDATE_PAYMENT_REQUEST:
        case SUBSCRIBE_CLUB_CHECKOUT_REQUEST:
        case SUBSCRIBE_MEMBER_CHECKOUT_REQUEST:
        case SUBSCRIBE_SUBSCRIPTION_INFO_REQUEST:
            return {
                ...state,
                cardError: null,
                loading: true,
            };
        case SUBSCRIBE_CLUB_CHECKOUT_SUCCESS:
        case SUBSCRIBE_MEMBER_CHECKOUT_SUCCESS:
        case SUBSCRIBE_MEMBER_CLEAR_ERROR:
            return {
                ...state,
                cardError: null,
                loading: false,
            };
        case SUBSCRIBE_UPDATE_PAYMENT_FAILURE:
        case SUBSCRIBE_CLUB_CHECKOUT_FAILURE:
        case SUBSCRIBE_MEMBER_CHECKOUT_FAILURE:
            return {
                ...state,
                loading: false,
                cardError: action.data.error,
            };
        case SUBSCRIBE_UPDATE_PAYMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                cardError: null,
                subscriptions: action.data.subscriptions || state.subscriptions,
                invoices: action.data.invoices || state.invoices,
            };
        case SUBSCRIBE_SUBSCRIPTION_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                cardError: null,
                subscriptions: action.data.subscriptions,
                invoices: action.data.invoices,
                hasTestClock: action.data.hasTestClock,
            };
        case SUBSCRIBE_MEMBER_RENEW_SUCCESS:
        case SUBSCRIBE_CLUB_RENEW_SUCCESS:
        case SUBSCRIBE_MEMBER_CANCEL_SUCCESS: {
            const subscriptions = state.subscriptions.map((item) => {
                if (item.id !== action.data.id) {
                    return item;
                }
                return {
                    ...item,
                    ...action.data,
                };
            });
            return {
                ...state,
                subscriptions,
            };
        }
        case SUBSCRIBE_INVOICE_PRINT:
            return {
                ...state,
                selectedInvoice: action.invoice,
            };
        default:
            return state;
    }
};
